import { render } from "./PlatformBenefits.vue?vue&type=template&id=9a2498aa&scoped=true"
import script from "./PlatformBenefits.vue?vue&type=script&lang=js"
export * from "./PlatformBenefits.vue?vue&type=script&lang=js"

import "./PlatformBenefits.vue?vue&type=style&index=0&id=9a2498aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a2498aa"]])

export default __exports__